import { createFileRoute } from '@tanstack/react-router'
import { ActivityReportPage } from '../../../components/AdminChallenges/ActivityReport'

export const Route = createFileRoute('/admin/challenges/$slug_/activity')({
  component: AdminChallengeActivityRoute,
})

function AdminChallengeActivityRoute() {
  const { slug } = Route.useParams()
  return <ActivityReportPage slug={slug} />
}
